import { Action } from '@ngrx/store';
import { JobStatusPickerOption } from './job-status-picker-popover-option.model';

export const LOAD = '[JobStatusPicker] Load';
export const LOAD_SUCCESS = '[JobStatusPicker] Load Success';
export const TOGGLE_OPTION = '[JobStatusPicker] Toggle Option';

export class ActionLoad implements Action {
    readonly type = LOAD;

    constructor(public payload: Array<string> = []) {

    }
}

export class ActionLoadSuccess implements Action {
    readonly type = LOAD_SUCCESS;

    constructor(public payload: Array<JobStatusPickerOption>) {

    }
}

export class ActionToggleOption implements Action {
    readonly type = TOGGLE_OPTION;

    constructor(public payload: JobStatusPickerOption) {

    }
}

export type Actions
    = ActionLoad
    | ActionLoadSuccess
    | ActionToggleOption;



// WEBPACK FOOTER //
// ./src/app/atoms/job-status-picker-popover/job-status-picker-popover.actions.ts